export default [
  {
    NAME: "Afghanistan",
    ALPHA_2: "AF",
    ALPHA_3: "AFG",
    CODE: 4
  },
  {
    NAME: "Åland Islands",
    ALPHA_2: "AX",
    ALPHA_3: "ALA",
    CODE: 248
  },
  {
    NAME: "Albania",
    ALPHA_2: "AL",
    ALPHA_3: "ALB",
    CODE: 8
  },
  {
    NAME: "Algeria",
    ALPHA_2: "DZ",
    ALPHA_3: "DZA",
    CODE: 12
  },
  {
    NAME: "American Samoa",
    ALPHA_2: "AS",
    ALPHA_3: "ASM",
    CODE: 16
  },
  {
    NAME: "Andorra",
    ALPHA_2: "AD",
    ALPHA_3: "AND",
    CODE: 20
  },
  {
    NAME: "Angola",
    ALPHA_2: "AO",
    ALPHA_3: "AGO",
    CODE: 24
  },
  {
    NAME: "Anguilla",
    ALPHA_2: "AI",
    ALPHA_3: "AIA",
    CODE: 660
  },
  {
    NAME: "Antarctica",
    ALPHA_2: "AQ",
    ALPHA_3: "ATA",
    CODE: 10
  },
  {
    NAME: "Antigua And Barbuda",
    ALPHA_2: "AG",
    ALPHA_3: "ATG",
    CODE: 28
  },
  {
    NAME: "Argentina",
    ALPHA_2: "AR",
    ALPHA_3: "ARG",
    CODE: 32
  },
  {
    NAME: "Armenia",
    ALPHA_2: "AM",
    ALPHA_3: "ARM",
    CODE: 51
  },
  {
    NAME: "Aruba",
    ALPHA_2: "AW",
    ALPHA_3: "ABW",
    CODE: 533
  },
  {
    NAME: "Australia",
    ALPHA_2: "AU",
    ALPHA_3: "AUS",
    CODE: 36
  },
  {
    NAME: "Austria",
    ALPHA_2: "AT",
    ALPHA_3: "AUT",
    CODE: 40
  },
  {
    NAME: "Azerbaijan",
    ALPHA_2: "AZ",
    ALPHA_3: "AZE",
    CODE: 31
  },
  {
    NAME: "Bahamas",
    ALPHA_2: "BS",
    ALPHA_3: "BHS",
    CODE: 44
  },
  {
    NAME: "Bahrain",
    ALPHA_2: "BH",
    ALPHA_3: "BHR",
    CODE: 48
  },
  {
    NAME: "Bangladesh",
    ALPHA_2: "BD",
    ALPHA_3: "BGD",
    CODE: 50
  },
  {
    NAME: "Barbados",
    ALPHA_2: "BB",
    ALPHA_3: "BRB",
    CODE: 52
  },
  {
    NAME: "Belarus",
    ALPHA_2: "BY",
    ALPHA_3: "BLR",
    CODE: 112
  },
  {
    NAME: "Belgium",
    ALPHA_2: "BE",
    ALPHA_3: "BEL",
    CODE: 56
  },
  {
    NAME: "Belize",
    ALPHA_2: "BZ",
    ALPHA_3: "BLZ",
    CODE: 84
  },
  {
    NAME: "Benin",
    ALPHA_2: "BJ",
    ALPHA_3: "BEN",
    CODE: 204
  },
  {
    NAME: "Bermuda",
    ALPHA_2: "BM",
    ALPHA_3: "BMU",
    CODE: 60
  },
  {
    NAME: "Bhutan",
    ALPHA_2: "BT",
    ALPHA_3: "BTN",
    CODE: 64
  },
  {
    NAME: "Bolivia",
    ALPHA_2: "BO",
    ALPHA_3: "BOL",
    CODE: 68
  },
  {
    NAME: "Bonaire, Sint Eustatius and Saba",
    ALPHA_2: "BQ",
    ALPHA_3: "BES",
    CODE: 535
  },
  {
    NAME: "Bosnia And Herzegovina",
    ALPHA_2: "BA",
    ALPHA_3: "BIH",
    CODE: 70
  },
  {
    NAME: "Botswana",
    ALPHA_2: "BW",
    ALPHA_3: "BWA",
    CODE: 72
  },
  {
    NAME: "Bouvet Island",
    ALPHA_2: "BV",
    ALPHA_3: "BVT",
    CODE: 74
  },
  {
    NAME: "Brazil",
    ALPHA_2: "BR",
    ALPHA_3: "BRA",
    CODE: 76
  },
  {
    NAME: "British Indian Ocean Territory",
    ALPHA_2: "IO",
    ALPHA_3: "IOT",
    CODE: 86
  },
  {
    NAME: "Brunei Darussalam",
    ALPHA_2: "BN",
    ALPHA_3: "BRN",
    CODE: 96
  },
  {
    NAME: "Bulgaria",
    ALPHA_2: "BG",
    ALPHA_3: "BGR",
    CODE: 100
  },
  {
    NAME: "Burkina Faso",
    ALPHA_2: "BF",
    ALPHA_3: "BFA",
    CODE: 854
  },
  {
    NAME: "Burundi",
    ALPHA_2: "BI",
    ALPHA_3: "BDI",
    CODE: 108
  },
  {
    NAME: "Cape Verde",
    ALPHA_2: "CV",
    ALPHA_3: "CPV",
    CODE: 132
  },
  {
    NAME: "Cambodia",
    ALPHA_2: "KH",
    ALPHA_3: "KHM",
    CODE: 116
  },
  {
    NAME: "Cameroon",
    ALPHA_2: "CM",
    ALPHA_3: "CMR",
    CODE: 120
  },
  {
    NAME: "Canada",
    ALPHA_2: "CA",
    ALPHA_3: "CAN",
    CODE: 124
  },
  {
    NAME: "Cayman Islands",
    ALPHA_2: "KY",
    ALPHA_3: "CYM",
    CODE: 136
  },
  {
    NAME: "Central African Republic",
    ALPHA_2: "CF",
    ALPHA_3: "CAF",
    CODE: 140
  },
  {
    NAME: "Chad",
    ALPHA_2: "TD",
    ALPHA_3: "TCD",
    CODE: 148
  },
  {
    NAME: "Chile",
    ALPHA_2: "CL",
    ALPHA_3: "CHL",
    CODE: 152
  },
  {
    NAME: "China",
    ALPHA_2: "CN",
    ALPHA_3: "CHN",
    CODE: 156
  },
  {
    NAME: "Christmas Island",
    ALPHA_2: "CX",
    ALPHA_3: "CXR",
    CODE: 162
  },
  {
    NAME: "Cocos (keeling) Islands",
    ALPHA_2: "CC",
    ALPHA_3: "CCK",
    CODE: 166
  },
  {
    NAME: "Colombia",
    ALPHA_2: "CO",
    ALPHA_3: "COL",
    CODE: 170
  },
  {
    NAME: "Comoros",
    ALPHA_2: "KM",
    ALPHA_3: "COM",
    CODE: 174
  },
  {
    NAME: "Congo",
    ALPHA_2: "CG",
    ALPHA_3: "COG",
    CODE: 178
  },
  {
    NAME: "Congo, The Democratic Republic Of The",
    ALPHA_2: "CD",
    ALPHA_3: "COD",
    CODE: 180
  },
  {
    NAME: "Cook Islands",
    ALPHA_2: "CK",
    ALPHA_3: "COK",
    CODE: 184
  },
  {
    NAME: "Costa Rica",
    ALPHA_2: "CR",
    ALPHA_3: "CRI",
    CODE: 188
  },
  {
    NAME: "CÔte D'ivoire",
    ALPHA_2: "CI",
    ALPHA_3: "CIV",
    CODE: 384
  },
  {
    NAME: "Croatia",
    ALPHA_2: "HR",
    ALPHA_3: "HRV",
    CODE: 191
  },
  {
    NAME: "Cuba",
    ALPHA_2: "CU",
    ALPHA_3: "CUB",
    CODE: 192
  },
  {
    NAME: "Curaçao",
    ALPHA_2: "CW",
    ALPHA_3: "CUW",
    CODE: 531
  },
  {
    NAME: "Cyprus",
    ALPHA_2: "CY",
    ALPHA_3: "CYP",
    CODE: 196
  },
  {
    NAME: "Czech Republic",
    ALPHA_2: "CZ",
    ALPHA_3: "CZE",
    CODE: 203
  },
  {
    NAME: "Denmark",
    ALPHA_2: "DK",
    ALPHA_3: "DNK",
    CODE: 208
  },
  {
    NAME: "Djibouti",
    ALPHA_2: "DJ",
    ALPHA_3: "DJI",
    CODE: 262
  },
  {
    NAME: "Dominica",
    ALPHA_2: "DM",
    ALPHA_3: "DMA",
    CODE: 212
  },
  {
    NAME: "Dominican Republic",
    ALPHA_2: "DO",
    ALPHA_3: "DOM",
    CODE: 214
  },
  {
    NAME: "Ecuador",
    ALPHA_2: "EC",
    ALPHA_3: "ECU",
    CODE: 218
  },
  {
    NAME: "Egypt",
    ALPHA_2: "EG",
    ALPHA_3: "EGY",
    CODE: 818
  },
  {
    NAME: "El Salvador",
    ALPHA_2: "SV",
    ALPHA_3: "SLV",
    CODE: 222
  },
  {
    NAME: "Equatorial Guinea",
    ALPHA_2: "GQ",
    ALPHA_3: "GNQ",
    CODE: 226
  },
  {
    NAME: "Eritrea",
    ALPHA_2: "ER",
    ALPHA_3: "ERI",
    CODE: 232
  },
  {
    NAME: "Estonia",
    ALPHA_2: "EE",
    ALPHA_3: "EST",
    CODE: 233
  },
  {
    NAME: "Swaziland",
    ALPHA_2: "SZ",
    ALPHA_3: "SWZ",
    CODE: 748
  },
  {
    NAME: "Ethiopia",
    ALPHA_2: "ET",
    ALPHA_3: "ETH",
    CODE: 231
  },
  {
    NAME: "Falkland Islands (malvinas)",
    ALPHA_2: "FK",
    ALPHA_3: "FLK",
    CODE: 238
  },
  {
    NAME: "Faroe Islands",
    ALPHA_2: "FO",
    ALPHA_3: "FRO",
    CODE: 234
  },
  {
    NAME: "Fiji",
    ALPHA_2: "FJ",
    ALPHA_3: "FJI",
    CODE: 242
  },
  {
    NAME: "Finland",
    ALPHA_2: "FI",
    ALPHA_3: "FIN",
    CODE: 246
  },
  {
    NAME: "France",
    ALPHA_2: "FR",
    ALPHA_3: "FRA",
    CODE: 250
  },
  {
    NAME: "French Guiana",
    ALPHA_2: "GF",
    ALPHA_3: "GUF",
    CODE: 254
  },
  {
    NAME: "French Polynesia",
    ALPHA_2: "PF",
    ALPHA_3: "PYF",
    CODE: 258
  },
  {
    NAME: "French Southern Territories",
    ALPHA_2: "TF",
    ALPHA_3: "ATF",
    CODE: 260
  },
  {
    NAME: "Gabon",
    ALPHA_2: "GA",
    ALPHA_3: "GAB",
    CODE: 266
  },
  {
    NAME: "The Gambia",
    ALPHA_2: "GM",
    ALPHA_3: "GMB",
    CODE: 270
  },
  {
    NAME: "Georgia",
    ALPHA_2: "GE",
    ALPHA_3: "GEO",
    CODE: 268
  },
  {
    NAME: "Germany",
    ALPHA_2: "DE",
    ALPHA_3: "DEU",
    CODE: 276
  },
  {
    NAME: "Ghana",
    ALPHA_2: "GH",
    ALPHA_3: "GHA",
    CODE: 288
  },
  {
    NAME: "Gibraltar",
    ALPHA_2: "GI",
    ALPHA_3: "GIB",
    CODE: 292
  },
  {
    NAME: "Greece",
    ALPHA_2: "GR",
    ALPHA_3: "GRC",
    CODE: 300
  },
  {
    NAME: "Greenland",
    ALPHA_2: "GL",
    ALPHA_3: "GRL",
    CODE: 304
  },
  {
    NAME: "Grenada",
    ALPHA_2: "GD",
    ALPHA_3: "GRD",
    CODE: 308
  },
  {
    NAME: "Guadeloupe",
    ALPHA_2: "GP",
    ALPHA_3: "GLP",
    CODE: 312
  },
  {
    NAME: "Guam",
    ALPHA_2: "GU",
    ALPHA_3: "GUM",
    CODE: 316
  },
  {
    NAME: "Guatemala",
    ALPHA_2: "GT",
    ALPHA_3: "GTM",
    CODE: 320
  },
  {
    NAME: "Guernsey",
    ALPHA_2: "GG",
    ALPHA_3: "GGY",
    CODE: 831
  },
  {
    NAME: "Guinea",
    ALPHA_2: "GN",
    ALPHA_3: "GIN",
    CODE: 324
  },
  {
    NAME: "Guinea-Bissau",
    ALPHA_2: "GW",
    ALPHA_3: "GNB",
    CODE: 624
  },
  {
    NAME: "Guyana",
    ALPHA_2: "GY",
    ALPHA_3: "GUY",
    CODE: 328
  },
  {
    NAME: "Haiti",
    ALPHA_2: "HT",
    ALPHA_3: "HTI",
    CODE: 332
  },
  {
    NAME: "Heard Island And Mcdonald Islands",
    ALPHA_2: "HM",
    ALPHA_3: "HMD",
    CODE: 334
  },
  {
    NAME: "Vatican City",
    ALPHA_2: "VA",
    ALPHA_3: "VAT",
    CODE: 336
  },
  {
    NAME: "Honduras",
    ALPHA_2: "HN",
    ALPHA_3: "HND",
    CODE: 340
  },
  {
    NAME: "Hong Kong",
    ALPHA_2: "HK",
    ALPHA_3: "HKG",
    CODE: 344
  },
  {
    NAME: "Hungary",
    ALPHA_2: "HU",
    ALPHA_3: "HUN",
    CODE: 348
  },
  {
    NAME: "Iceland",
    ALPHA_2: "IS",
    ALPHA_3: "ISL",
    CODE: 352
  },
  {
    NAME: "India",
    ALPHA_2: "IN",
    ALPHA_3: "IND",
    CODE: 356
  },
  {
    NAME: "Indonesia",
    ALPHA_2: "ID",
    ALPHA_3: "IDN",
    CODE: 360
  },
  {
    NAME: "Iran",
    ALPHA_2: "IR",
    ALPHA_3: "IRN",
    CODE: 364
  },
  {
    NAME: "Iraq",
    ALPHA_2: "IQ",
    ALPHA_3: "IRQ",
    CODE: 368
  },
  {
    NAME: "Ireland",
    ALPHA_2: "IE",
    ALPHA_3: "IRL",
    CODE: 372
  },
  {
    NAME: "Isle Of Man",
    ALPHA_2: "IM",
    ALPHA_3: "IMN",
    CODE: 833
  },
  {
    NAME: "Israel",
    ALPHA_2: "IL",
    ALPHA_3: "ISR",
    CODE: 376
  },
  {
    NAME: "Italy",
    ALPHA_2: "IT",
    ALPHA_3: "ITA",
    CODE: 380
  },
  {
    NAME: "Jamaica",
    ALPHA_2: "JM",
    ALPHA_3: "JAM",
    CODE: 388
  },
  {
    NAME: "Japan",
    ALPHA_2: "JP",
    ALPHA_3: "JPN",
    CODE: 392
  },
  {
    NAME: "Jersey",
    ALPHA_2: "JE",
    ALPHA_3: "JEY",
    CODE: 832
  },
  {
    NAME: "Jordan",
    ALPHA_2: "JO",
    ALPHA_3: "JOR",
    CODE: 400
  },
  {
    NAME: "Kazakhstan",
    ALPHA_2: "KZ",
    ALPHA_3: "KAZ",
    CODE: 398
  },
  {
    NAME: "Kenya",
    ALPHA_2: "KE",
    ALPHA_3: "KEN",
    CODE: 404
  },
  {
    NAME: "Kiribati",
    ALPHA_2: "KI",
    ALPHA_3: "KIR",
    CODE: 296
  },
  {
    NAME: "North Korea",
    ALPHA_2: "KP",
    ALPHA_3: "PRK",
    CODE: 408
  },
  {
    NAME: "South Korea",
    ALPHA_2: "KR",
    ALPHA_3: "KOR",
    CODE: 410
  },
  {
    NAME: "Kuwait",
    ALPHA_2: "KW",
    ALPHA_3: "KWT",
    CODE: 414
  },
  {
    NAME: "Kyrgyzstan",
    ALPHA_2: "KG",
    ALPHA_3: "KGZ",
    CODE: 417
  },
  {
    NAME: "Lao People's Democratic Republic",
    ALPHA_2: "LA",
    ALPHA_3: "LAO",
    CODE: 418
  },
  {
    NAME: "Latvia",
    ALPHA_2: "LV",
    ALPHA_3: "LVA",
    CODE: 428
  },
  {
    NAME: "Lebanon",
    ALPHA_2: "LB",
    ALPHA_3: "LBN",
    CODE: 422
  },
  {
    NAME: "Lesotho",
    ALPHA_2: "LS",
    ALPHA_3: "LSO",
    CODE: 426
  },
  {
    NAME: "Liberia",
    ALPHA_2: "LR",
    ALPHA_3: "LBR",
    CODE: 430
  },
  {
    NAME: "Libya",
    ALPHA_2: "LY",
    ALPHA_3: "LBY",
    CODE: 434
  },
  {
    NAME: "Liechtenstein",
    ALPHA_2: "LI",
    ALPHA_3: "LIE",
    CODE: 438
  },
  {
    NAME: "Lithuania",
    ALPHA_2: "LT",
    ALPHA_3: "LTU",
    CODE: 440
  },
  {
    NAME: "Luxembourg",
    ALPHA_2: "LU",
    ALPHA_3: "LUX",
    CODE: 442
  },
  {
    NAME: "Macao",
    ALPHA_2: "MO",
    ALPHA_3: "MAC",
    CODE: 446
  },
  {
    NAME: "Republic of Macedonia",
    ALPHA_2: "MK",
    ALPHA_3: "MKD",
    CODE: 807
  },
  {
    NAME: "Madagascar",
    ALPHA_2: "MG",
    ALPHA_3: "MDG",
    CODE: 450
  },
  {
    NAME: "Malawi",
    ALPHA_2: "MW",
    ALPHA_3: "MWI",
    CODE: 454
  },
  {
    NAME: "Malaysia",
    ALPHA_2: "MY",
    ALPHA_3: "MYS",
    CODE: 458
  },
  {
    NAME: "Maldives",
    ALPHA_2: "MV",
    ALPHA_3: "MDV",
    CODE: 462
  },
  {
    NAME: "Mali",
    ALPHA_2: "ML",
    ALPHA_3: "MLI",
    CODE: 466
  },
  {
    NAME: "Malta",
    ALPHA_2: "MT",
    ALPHA_3: "MLT",
    CODE: 470
  },
  {
    NAME: "Marshall Islands",
    ALPHA_2: "MH",
    ALPHA_3: "MHL",
    CODE: 584
  },
  {
    NAME: "Martinique",
    ALPHA_2: "MQ",
    ALPHA_3: "MTQ",
    CODE: 474
  },
  {
    NAME: "Mauritania",
    ALPHA_2: "MR",
    ALPHA_3: "MRT",
    CODE: 478
  },
  {
    NAME: "Mauritius",
    ALPHA_2: "MU",
    ALPHA_3: "MUS",
    CODE: 480
  },
  {
    NAME: "Mayotte",
    ALPHA_2: "YT",
    ALPHA_3: "MYT",
    CODE: 175
  },
  {
    NAME: "Mexico",
    ALPHA_2: "MX",
    ALPHA_3: "MEX",
    CODE: 484
  },
  {
    NAME: "Micronesia, Federated States Of",
    ALPHA_2: "FM",
    ALPHA_3: "FSM",
    CODE: 583
  },
  {
    NAME: "Moldova",
    ALPHA_2: "MD",
    ALPHA_3: "MDA",
    CODE: 498
  },
  {
    NAME: "Monaco",
    ALPHA_2: "MC",
    ALPHA_3: "MCO",
    CODE: 492
  },
  {
    NAME: "Mongolia",
    ALPHA_2: "MN",
    ALPHA_3: "MNG",
    CODE: 496
  },
  {
    NAME: "Montenegro",
    ALPHA_2: "ME",
    ALPHA_3: "MNE",
    CODE: 499
  },
  {
    NAME: "Montserrat",
    ALPHA_2: "MS",
    ALPHA_3: "MSR",
    CODE: 500
  },
  {
    NAME: "Morocco",
    ALPHA_2: "MA",
    ALPHA_3: "MAR",
    CODE: 504
  },
  {
    NAME: "Mozambique",
    ALPHA_2: "MZ",
    ALPHA_3: "MOZ",
    CODE: 508
  },
  {
    NAME: "Burma",
    ALPHA_2: "MM",
    ALPHA_3: "MMR",
    CODE: 104
  },
  {
    NAME: "Namibia",
    ALPHA_2: "NA",
    ALPHA_3: "NAM",
    CODE: 516
  },
  {
    NAME: "Nauru",
    ALPHA_2: "NR",
    ALPHA_3: "NRU",
    CODE: 520
  },
  {
    NAME: "Nepal",
    ALPHA_2: "NP",
    ALPHA_3: "NPL",
    CODE: 524
  },
  {
    NAME: "Netherlands",
    ALPHA_2: "NL",
    ALPHA_3: "NLD",
    CODE: 528
  },
  {
    NAME: "New Caledonia",
    ALPHA_2: "NC",
    ALPHA_3: "NCL",
    CODE: 540
  },
  {
    NAME: "New Zealand",
    ALPHA_2: "NZ",
    ALPHA_3: "NZL",
    CODE: 554
  },
  {
    NAME: "Nicaragua",
    ALPHA_2: "NI",
    ALPHA_3: "NIC",
    CODE: 558
  },
  {
    NAME: "Niger",
    ALPHA_2: "NE",
    ALPHA_3: "NER",
    CODE: 562
  },
  {
    NAME: "Nigeria",
    ALPHA_2: "NG",
    ALPHA_3: "NGA",
    CODE: 566
  },
  {
    NAME: "Niue",
    ALPHA_2: "NU",
    ALPHA_3: "NIU",
    CODE: 570
  },
  {
    NAME: "Norfolk Island",
    ALPHA_2: "NF",
    ALPHA_3: "NFK",
    CODE: 574
  },
  {
    NAME: "Northern Mariana Islands",
    ALPHA_2: "MP",
    ALPHA_3: "MNP",
    CODE: 580
  },
  {
    NAME: "Norway",
    ALPHA_2: "NO",
    ALPHA_3: "NOR",
    CODE: 578
  },
  {
    NAME: "Oman",
    ALPHA_2: "OM",
    ALPHA_3: "OMN",
    CODE: 512
  },
  {
    NAME: "Pakistan",
    ALPHA_2: "PK",
    ALPHA_3: "PAK",
    CODE: 586
  },
  {
    NAME: "Palau",
    ALPHA_2: "PW",
    ALPHA_3: "PLW",
    CODE: 585
  },
  {
    NAME: "Palestinian Territory",
    ALPHA_2: "PS",
    ALPHA_3: "PSE",
    CODE: 275
  },
  {
    NAME: "Panama",
    ALPHA_2: "PA",
    ALPHA_3: "PAN",
    CODE: 591
  },
  {
    NAME: "Papua New Guinea",
    ALPHA_2: "PG",
    ALPHA_3: "PNG",
    CODE: 598
  },
  {
    NAME: "Paraguay",
    ALPHA_2: "PY",
    ALPHA_3: "PRY",
    CODE: 600
  },
  {
    NAME: "Peru",
    ALPHA_2: "PE",
    ALPHA_3: "PER",
    CODE: 604
  },
  {
    NAME: "Philippines",
    ALPHA_2: "PH",
    ALPHA_3: "PHL",
    CODE: 608
  },
  {
    NAME: "Pitcairn",
    ALPHA_2: "PN",
    ALPHA_3: "PCN",
    CODE: 612
  },
  {
    NAME: "Poland",
    ALPHA_2: "PL",
    ALPHA_3: "POL",
    CODE: 616
  },
  {
    NAME: "Portugal",
    ALPHA_2: "PT",
    ALPHA_3: "PRT",
    CODE: 620
  },
  {
    NAME: "Puerto Rico",
    ALPHA_2: "PR",
    ALPHA_3: "PRI",
    CODE: 630
  },
  {
    NAME: "Qatar",
    ALPHA_2: "QA",
    ALPHA_3: "QAT",
    CODE: 634
  },
  {
    NAME: "RÉunion",
    ALPHA_2: "RE",
    ALPHA_3: "REU",
    CODE: 638
  },
  {
    NAME: "Romania",
    ALPHA_2: "RO",
    ALPHA_3: "ROU",
    CODE: 642
  },
  {
    NAME: "Russian Federation",
    ALPHA_2: "RU",
    ALPHA_3: "RUS",
    CODE: 643
  },
  {
    NAME: "Rwanda",
    ALPHA_2: "RW",
    ALPHA_3: "RWA",
    CODE: 646
  },
  {
    NAME: "Saint Barthélemy",
    ALPHA_2: "BL",
    ALPHA_3: "BLM",
    CODE: 652
  },
  {
    NAME: "Saint Helena",
    ALPHA_2: "SH",
    ALPHA_3: "SHN",
    CODE: 654
  },
  {
    NAME: "Saint Kitts And Nevis",
    ALPHA_2: "KN",
    ALPHA_3: "KNA",
    CODE: 659
  },
  {
    NAME: "Saint Lucia",
    ALPHA_2: "LC",
    ALPHA_3: "LCA",
    CODE: 662
  },
  {
    NAME: "Saint Martin (French part)",
    ALPHA_2: "MF",
    ALPHA_3: "MAF",
    CODE: 663
  },
  {
    NAME: "Saint Pierre And Miquelon",
    ALPHA_2: "PM",
    ALPHA_3: "SPM",
    CODE: 666
  },
  {
    NAME: "Saint Vincent and the Grenadines",
    ALPHA_2: "VC",
    ALPHA_3: "VCT",
    CODE: 670
  },
  {
    NAME: "Samoa",
    ALPHA_2: "WS",
    ALPHA_3: "WSM",
    CODE: 882
  },
  {
    NAME: "San Marino",
    ALPHA_2: "SM",
    ALPHA_3: "SMR",
    CODE: 674
  },
  {
    NAME: "Sao Tome And Principe",
    ALPHA_2: "ST",
    ALPHA_3: "STP",
    CODE: 678
  },
  {
    NAME: "Saudi Arabia",
    ALPHA_2: "SA",
    ALPHA_3: "SAU",
    CODE: 682
  },
  {
    NAME: "Senegal",
    ALPHA_2: "SN",
    ALPHA_3: "SEN",
    CODE: 686
  },
  {
    NAME: "Serbia",
    ALPHA_2: "RS",
    ALPHA_3: "SRB",
    CODE: 688
  },
  {
    NAME: "Seychelles",
    ALPHA_2: "SC",
    ALPHA_3: "SYC",
    CODE: 690
  },
  {
    NAME: "Sierra Leone",
    ALPHA_2: "SL",
    ALPHA_3: "SLE",
    CODE: 694
  },
  {
    NAME: "Singapore",
    ALPHA_2: "SG",
    ALPHA_3: "SGP",
    CODE: 702
  },
  {
    NAME: "Sint Maarten (Dutch part)",
    ALPHA_2: "SX",
    ALPHA_3: "SXM",
    CODE: 534
  },
  {
    NAME: "Slovakia",
    ALPHA_2: "SK",
    ALPHA_3: "SVK",
    CODE: 703
  },
  {
    NAME: "Slovenia",
    ALPHA_2: "SI",
    ALPHA_3: "SVN",
    CODE: 705
  },
  {
    NAME: "Solomon Islands",
    ALPHA_2: "SB",
    ALPHA_3: "SLB",
    CODE: 90
  },
  {
    NAME: "Somalia",
    ALPHA_2: "SO",
    ALPHA_3: "SOM",
    CODE: 706
  },
  {
    NAME: "South Africa",
    ALPHA_2: "ZA",
    ALPHA_3: "ZAF",
    CODE: 710
  },
  {
    NAME: "South Georgia And The South Sandwich Islands",
    ALPHA_2: "GS",
    ALPHA_3: "SGS",
    CODE: 239
  },
  {
    NAME: "South Sudan",
    ALPHA_2: "SS",
    ALPHA_3: "SSD",
    CODE: 728
  },
  {
    NAME: "Spain",
    ALPHA_2: "ES",
    ALPHA_3: "ESP",
    CODE: 724
  },
  {
    NAME: "Sri Lanka",
    ALPHA_2: "LK",
    ALPHA_3: "LKA",
    CODE: 144
  },
  {
    NAME: "Sudan",
    ALPHA_2: "SD",
    ALPHA_3: "SDN",
    CODE: 729
  },
  {
    NAME: "SuriNAME",
    ALPHA_2: "SR",
    ALPHA_3: "SUR",
    CODE: 740
  },
  {
    NAME: "Svalbard And Jan Mayen",
    ALPHA_2: "SJ",
    ALPHA_3: "SJM",
    CODE: 744
  },
  {
    NAME: "Sweden",
    ALPHA_2: "SE",
    ALPHA_3: "SWE",
    CODE: 752
  },
  {
    NAME: "Switzerland",
    ALPHA_2: "CH",
    ALPHA_3: "CHE",
    CODE: 756
  },
  {
    NAME: "Syrian Arab Republic",
    ALPHA_2: "SY",
    ALPHA_3: "SYR",
    CODE: 760
  },
  {
    NAME: "Taiwan",
    ALPHA_2: "TW",
    ALPHA_3: "TWN",
    CODE: 158
  },
  {
    NAME: "Tajikistan",
    ALPHA_2: "TJ",
    ALPHA_3: "TJK",
    CODE: 762
  },
  {
    NAME: "Tanzania, United Republic Of",
    ALPHA_2: "TZ",
    ALPHA_3: "TZA",
    CODE: 834
  },
  {
    NAME: "Thailand",
    ALPHA_2: "TH",
    ALPHA_3: "THA",
    CODE: 764
  },
  {
    NAME: "East Timor",
    ALPHA_2: "TL",
    ALPHA_3: "TLS",
    CODE: 626
  },
  {
    NAME: "Togo",
    ALPHA_2: "TG",
    ALPHA_3: "TGO",
    CODE: 768
  },
  {
    NAME: "Tokelau",
    ALPHA_2: "TK",
    ALPHA_3: "TKL",
    CODE: 772
  },
  {
    NAME: "Tonga",
    ALPHA_2: "TO",
    ALPHA_3: "TON",
    CODE: 776
  },
  {
    NAME: "Trinidad And Tobago",
    ALPHA_2: "TT",
    ALPHA_3: "TTO",
    CODE: 780
  },
  {
    NAME: "Tunisia",
    ALPHA_2: "TN",
    ALPHA_3: "TUN",
    CODE: 788
  },
  {
    NAME: "Turkey",
    ALPHA_2: "TR",
    ALPHA_3: "TUR",
    CODE: 792
  },
  {
    NAME: "Turkmenistan",
    ALPHA_2: "TM",
    ALPHA_3: "TKM",
    CODE: 795
  },
  {
    NAME: "Turks And Caicos Islands",
    ALPHA_2: "TC",
    ALPHA_3: "TCA",
    CODE: 796
  },
  {
    NAME: "Tuvalu",
    ALPHA_2: "TV",
    ALPHA_3: "TUV",
    CODE: 798
  },
  {
    NAME: "Uganda",
    ALPHA_2: "UG",
    ALPHA_3: "UGA",
    CODE: 800
  },
  {
    NAME: "Ukraine",
    ALPHA_2: "UA",
    ALPHA_3: "UKR",
    CODE: 804
  },
  {
    NAME: "United Arab Emirates",
    ALPHA_2: "AE",
    ALPHA_3: "ARE",
    CODE: 784
  },
  {
    NAME: "United Kingdom",
    ALPHA_2: "GB",
    ALPHA_3: "GBR",
    CODE: 826
  },
  {
    NAME: "United States",
    ALPHA_2: "US",
    ALPHA_3: "USA",
    CODE: 840
  },
  {
    NAME: "United States Minor Outlying Islands",
    ALPHA_2: "UM",
    ALPHA_3: "UMI",
    CODE: 581
  },
  {
    NAME: "Uruguay",
    ALPHA_2: "UY",
    ALPHA_3: "URY",
    CODE: 858
  },
  {
    NAME: "Uzbekistan",
    ALPHA_2: "UZ",
    ALPHA_3: "UZB",
    CODE: 860
  },
  {
    NAME: "Vanuatu",
    ALPHA_2: "VU",
    ALPHA_3: "VUT",
    CODE: 548
  },
  {
    NAME: "Venezuela",
    ALPHA_2: "VE",
    ALPHA_3: "VEN",
    CODE: 862
  },
  {
    NAME: "Viet Nam",
    ALPHA_2: "VN",
    ALPHA_3: "VNM",
    CODE: 704
  },
  {
    NAME: "British Virgin Islands",
    ALPHA_2: "VG",
    ALPHA_3: "VGB",
    CODE: 92
  },
  {
    NAME: "Virgin Islands, U.s.",
    ALPHA_2: "VI",
    ALPHA_3: "VIR",
    CODE: 850
  },
  {
    NAME: "Wallis And Futuna",
    ALPHA_2: "WF",
    ALPHA_3: "WLF",
    CODE: 876
  },
  {
    NAME: "Western Sahara",
    ALPHA_2: "EH",
    ALPHA_3: "ESH",
    CODE: 732
  },
  {
    NAME: "Yemen",
    ALPHA_2: "YE",
    ALPHA_3: "YEM",
    CODE: 887
  },
  {
    NAME: "Zambia",
    ALPHA_2: "ZM",
    ALPHA_3: "ZMB",
    CODE: 894
  },
  {
    NAME: "Zimbabwe",
    ALPHA_2: "ZW",
    ALPHA_3: "ZWE",
    CODE: 716
  }
]
